// Modules
import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';

import { PageContent } from 'components/page';
import { Table } from 'components/content-containers/tables/tables';
import Agreement from 'services/data/agreement';
import AgreementLink from 'components/models/agreement/agreement-link';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';
import ShortDate from 'components/widgets/dates/short-date';

import * as actions from '../store/actions';

export default function CompanyAgreements({ id, currentUser }) {
  const { data: company } = actions.useCompany(id);
  const { data: agreements } = actions.useCompanyAgreements(id);

  if (!agreements) return null;

  const sorted = _.orderBy(agreements, ['endDate', 'startDate'], ['desc', 'desc']);
  const isLead = Person.isLead(currentUser);

  return (
    <PageContent>
      <div>
        { isLead &&
          <Link to={`/companies/${company.id}/agreements/add`} className="full-page-add-link offset-page-padding btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>New Agreement</span>
            </div>
            <SVG src="svg/agreement.svg" />
          </Link>
        }
        <div className="agreements-table">
          <Table>
            <thead>
              <tr>
                <th>Agreement</th>
                <th>Start</th>
                <th>End</th>
                <th>Department</th>
                <th>Billing</th>
              </tr>
            </thead>
            <tbody>
              {_.map(sorted, (agreement) => {
                const expired = agreement.endDate && moment().startOf('day').isAfter(agreement.endDate);

                return (
                  <tr key={agreement.id} className={classNames({ 'status-expired': expired })}>
                    <td><AgreementLink agreement={agreement}>{expired && '[expired] '} {agreement.title}</AgreementLink></td>
                    <td><ShortDate date={agreement.startDate} /></td>
                    <td><ShortDate date={agreement.endDate} /></td>
                    <td>{agreement.department}</td>
                    <td>{Agreement.getBillingTypes(agreement)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </PageContent>
  );
}

// Component
// class CompanyAgreementsOld extends React.Component {
//   render() {
//     const { agreements, company, currentUser } = this.props;
//     const sorted = _.orderBy(agreements, ['endDate', 'startDate'], ['desc', 'desc']);
//     const isLead = Person.isLead(currentUser);

//     return (
//       <PageContent>
//         <div>
//           { isLead &&
//             <Link to={`/companies/${company.id}/agreements/add`} className="full-page-add-link offset-page-padding btn-success">
//               <div>
//                 <SVG src="svg/add.svg" className="add mr-2" />
//                 <span>New Agreement</span>
//               </div>
//               <SVG src="svg/agreement.svg" />
//             </Link>
//           }
//           <div className="agreements-table">
//             <Table>
//               <thead>
//                 <tr>
//                   <th>Agreement</th>
//                   <th>Start</th>
//                   <th>End</th>
//                   <th>Department</th>
//                   <th>Billing</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {_.map(sorted, (agreement) => {
//                   const expired = agreement.endDate && moment().startOf('day').isAfter(agreement.endDate);

//                   return (
//                     <tr key={agreement.id} className={classNames({ 'status-expired': expired })}>
//                       <td><AgreementLink agreement={agreement}>{expired && '[expired] '} {agreement.title}</AgreementLink></td>
//                       <td><ShortDate date={agreement.startDate} /></td>
//                       <td><ShortDate date={agreement.endDate} /></td>
//                       <td>{agreement.department}</td>
//                       <td>{Agreement.getBillingTypes(agreement)}</td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           </div>
//         </div>
//       </PageContent>
//     );
//   }
// }
